import course from './course';
import ucRouter from './uc';
import order from './order';
import active from './active';
import transfer from './transfer';
import wechatPublicAccountQrCode from './wechatPublicAccountQrCode';
import activationCode from './activation-code';
import addWx from './add-wx.js';


const routerList = [
  ...course, 
  ...ucRouter, 
  ...order, 
  ...active, 
  ...transfer, 
  ...wechatPublicAccountQrCode, 
  ...activationCode, 
  ...addWx
];

export default routerList;
